import Application from "../../Application";
import GetAllCaseDecisionTypesInteractor from "../../caseDecisions/interactor/GetAllCaseDecisionTypesInteractor";
import OrganisationCaseDecisionTypesPresenter, {
  IOrganisationCaseDecisionTypesPresenter
} from "../presenter/OrganisationCaseDecisionTypesPresenter";
import GetAllOrganisationIndexCategoriesInteractor from "./GetAllOrganisationIndexCategoriesInteractor";
import GetOrganisationCaseDecisionTypesInteractor from "./GetOrganisationCaseDecisionTypesInteractor";

export default class ShowOrganisationCaseDecisionTypesInteractor {
  private application: Application;
  private output?: IOrganisationCaseDecisionTypesPresenter;
  private getOrganisationCaseDecisionTypesInteractor: GetOrganisationCaseDecisionTypesInteractor;
  private getAllOrganisationIndexCategoriesInteractor: GetAllOrganisationIndexCategoriesInteractor;
  private getAllCaseDecisionTypesInteractor: GetAllCaseDecisionTypesInteractor;

  constructor({
    application,
    getOrganisationCaseDecisionTypes,
    getAllCaseDecisionTypes,
    getAllOrganisationIndexCategories
  }) {
    this.application = application;
    this.getOrganisationCaseDecisionTypesInteractor =
      getOrganisationCaseDecisionTypes;
    this.getAllOrganisationIndexCategoriesInteractor =
      getAllOrganisationIndexCategories;
    this.getAllCaseDecisionTypesInteractor = getAllCaseDecisionTypes;
  }
  private async getAllOrganisationCaseDecisionTypes(organisationId) {
    return this.getOrganisationCaseDecisionTypesInteractor.execute(
      organisationId
    );
  }

  private async getAllCaseDecisionTypes() {
    return this.getAllCaseDecisionTypesInteractor.execute();
  }
  private async getAllOrganisationIndexCategories(organisationId) {
    return this.getAllOrganisationIndexCategoriesInteractor.execute(
      organisationId
    );
  }

  private async getReferenceLists(organisationId) {
    return Promise.all([
      this.getAllCaseDecisionTypes(),
      this.getAllOrganisationIndexCategories(organisationId),
      this.getAllOrganisationCaseDecisionTypes(organisationId)
    ]);
  }

  execute(organisationId: number) {
    this.output = OrganisationCaseDecisionTypesPresenter({
      application: this.application,

      initialState: {
        organisationCaseDecisionTypes: [],
        organisationId,
        modalVisible: false,
        currentCaseDecisionTypeId: undefined,
        caseDecisionTypes: [],
        codeList: [],
        organisationIndexCategories: [],
        caseDecisionTypeIndexCategories: [],
        assignTypesToOrganisationModalVisible: false
      }
    });

    this.getReferenceLists(organisationId).then(
      ([
        caseDecisionTypes,
        organisationIndexCategories,
        organisationCaseDecisionTypes
      ]) =>
        this.output?.loadReferenceValues(
          organisationId,
          organisationIndexCategories,
          caseDecisionTypes,
          organisationCaseDecisionTypes
        )
    );

    return this.output;
  }
}
